import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ResidencesPage = lazy(() => import('../pages/residences/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const LocationPage = lazy(() => import('../pages/location/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AdminPage = lazy(() => import('../pages/admin/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/residences',
    element: <ResidencesPage />
  },
  {
    path: '/gallery',
    element: <GalleryPage />
  },
  {
    path: '/gallery-capella-residency-westlands',
    element: <GalleryPage />
  },
  {
    path: '/location-westlands-nairobi',
    element: <LocationPage />
  },
  {
    path: '/contact-capella-residency',
    element: <ContactPage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;